(async () => {
  if (!customElements.get('slider-banner')) {
    const { Swiper } = await import('swiper');
    const { A11y, Autoplay, Navigation, EffectFade } = await import('swiper/modules');


    console.log(Swiper);
    class SliderBanner extends HTMLElement {
      constructor() {
        super();

        const videoContainers = this.querySelectorAll('.swiper-slide:has(.slider__video)');

        // Initialize play/pause functionality if there are video slides
        this.handlePlayPause(videoContainers);

        this.swiper = this.querySelector('[data-swiper]');

        const self = this;

        if (!this.swiper) return;

        this.swiperOptions = {
          modules: [A11y, Autoplay, Navigation, EffectFade],
          threshold: 10,
        };

        if (this.swiper.dataset.options) {
          const options = JSON.parse(this.swiper.dataset.options);
          if (options) {
            this.swiperOptions = { ...this.swiperOptions, ...options };
          }
        }

        this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

        const defineCommonVars = (swiperInst) => {
          this.activeSlide = swiperInst.slides[swiperInst.activeIndex];
          this.activeSlideInner = this.activeSlide.querySelector('.slider__slide-inner');
          this.activeSlideContent = this.activeSlide.querySelector('.slider__content');
          this.activeSlideVideoBtn = this.activeSlide.querySelector('.slider__video-button');

          this.prevSlide = swiperInst.slides[swiperInst.previousIndex];
          this.prevSlideInner = this.prevSlide.querySelector('.slider__slide-inner');
        };

        const handleClassChange = (direction) => {
          if (self.activeSlideContent) self.activeSlideContent.style.opacity = 0;
          if (self.activeSlideVideoBtn) self.activeSlideVideoBtn.style.opacity = 0;

          self.activeSlideInner.classList.remove(
            'prev-forward',
            'prev-backward',
            'active-backward',
            'active-forward'
          );
          self.prevSlideInner.classList.remove(
            'prev-forward',
            'prev-backward',
            'active-backward',
            'active-forward'
          );

          self.activeSlideInner.classList.add(`active-${direction}`);
          self.prevSlideInner.classList.add(`prev-${direction}`);
        };

        const handleSwiperNav = (swiperInst) => {
          swiperInst.navigation.disable();
          setTimeout(() => {
            swiperInst.navigation.enable();
          }, 1500);
        };

        if (!Shopify.designMode) {
          this.swiperInstance.on('slideChange', function () {
            defineCommonVars(this);
            handleSwiperNav(this);

            // Pause all videos if any exist
            if (videoContainers.length) {
              videoContainers.forEach((container) => {
                const video = container.querySelector('video');
                const playIcon = container.querySelector('.slider__video-play');
                const pauseIcon = container.querySelector('.slider__video-pause');

                if (video && !video.paused) {
                  video.pause();
                  playIcon?.classList.remove('hidden');
                  pauseIcon?.classList.add('hidden');
                }
              });
            }

            // Play the video in the active slide if it has autoplay
            const activeVideo = self.activeSlide.querySelector('video');
            if (activeVideo && activeVideo.hasAttribute('autoplay')) {
              activeVideo.play();
            }
          });

          this.swiperInstance.on('slideNextTransitionStart', function () {
            handleClassChange('forward');
          });

          this.swiperInstance.on('slidePrevTransitionStart', function () {
            handleClassChange('backward');
            self.prevSlide.style.opacity = 1;
            setTimeout(() => {
              self.prevSlide.style.opacity = 0;
            }, 1500);
          });
        }

        // Play the video in the initial active slide if it has autoplay
        const initialActiveVideo =
          this.swiperInstance.slides[this.swiperInstance.activeIndex].querySelector('video');
        if (initialActiveVideo && initialActiveVideo.hasAttribute('autoplay')) {
          initialActiveVideo.play();
        }

        if (Shopify.designMode) {
          window.addEventListener('shopify:section:load', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
          });

          window.addEventListener('shopify:block:select', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            this.handleBlockSelect(event);
          });

          window.addEventListener('shopify:block:deselect', (event) => {
            this.swiperInstance.update();
            if (this.swiperOptions.navigation) {
              this.swiperInstance.navigation.init();
              this.swiperInstance.navigation.update();
            }
            this.handleBlockSelect(event);
          });
        }
      }

      handlePlayPause(videoContainers) {
        if (!videoContainers.length) return;

        videoContainers.forEach((container) => {
          if (!container) return;

          const playButton = container.querySelector('.slider__video-button');
          const video = container.querySelector('video');
          const playIcon = container.querySelector('.slider__video-play');
          const pauseIcon = container.querySelector('.slider__video-pause');

          // Only remove classes if the play button exists (i.e., autoplay is disabled)
          if (playButton) {
            playButton.classList.remove('opacity-0', 'cursor-none');

            playButton.addEventListener('click', () => {
              if (!video) return;
              video.paused ? video.play() : video.pause();
              playIcon?.classList.toggle('hidden', !video.paused);
              pauseIcon?.classList.toggle('hidden', video.paused);
            });
          }
        });
      }

      handleBlockSelect(event) {
        if (!('swiperSlideIndex' in event.target.dataset)) {
          return;
        }

        let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if (this.swiperOptions.loop) {
          swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        const sliderToUpdate = event.target.closest('[data-swiper]');
        sliderToUpdate.swiper.slideTo(swipeToSlideIndex, 1000);
      }
    }

    window.SliderBanner = SliderBanner;

    customElements.define('slider-banner', SliderBanner);
  }
})();
